import React from "react";
import { connect } from "react-redux";
import { InpageNavLink } from "../../../components/InPageNavMenu";
// import { frontloadConnect } from "react-frontload";
import {
  isResourceReadable,
  // loadResourcePermissions,
} from "../actions";

// const frontload = async (props) => {
//   const resources = [];
//   (props.links || []).forEach(link => {
//     if (link.resource) {
//       resources.push(link.resource);
//     }
//   })
//   await props.getResourcePermissionList(resources);
// };

const mapStateToProps = (state) => {
  return {
    permissions: state.permissions.permissionMap,
  };
};

const mapDispatchToProps = (dispatch) => ({
  // getResourcePermission: (...args) =>
  //   dispatch(loadResourcePermissions(...args)),
});

const evaluatePermissions = (
  permissions,
  resource,
  resources,
  resourceEvaluation = "or",
) => {
  if (!resource && !resources) {
    return true;
  }
  const isORComparism = `${resourceEvaluation}`.toLowerCase() === "or";
  let result = isORComparism ? false : true;
  if (resource) {
    result = isResourceReadable(resource, permissions);
  } else {
    resources.forEach((item) => {
      if (isORComparism) {
        result = result || isResourceReadable(item, permissions);
      } else {
        result = result || isResourceReadable(item, permissions);
      }
    });
  }
  return result;
};

const PermissionInPageNavMenu = ({
  className = "under-wizard-title",
  contentClassName = "margin-big-top",
  linkClassName = "w3-border",
  links,
  initialActiveId = "basisdaten",
  bottomId = "",
  scrollSpy = true,
  permissions,
}) => {
  // console.log("PermissionInPageNavMenu()", permissions);
  const [activeId, setActiveId] = React.useState(initialActiveId);
  const [refPosition, setRefPosition] = React.useState(null);
  const [clickData, setClickData] = React.useState({
    id: null,
    timestamp: 0,
  });

  React.useEffect(() => {
    if (!scrollSpy) {
      return;
    }
    const handleScroll = () => {
      const tolerance = 50;
      const menuTargets = [];
      links.forEach((item, index) => {
        const target = document.getElementById(`${item.to}`);
        if (target) {
          const top = target.getBoundingClientRect().y;
          menuTargets.push({
            target,
            id: item.to,
            top,
          });
          if (index > 0 && menuTargets.length > 1) {
            menuTargets[index - 1].btm = top;
          }
        }
      });
      let scrollingDown = true;
      let update = false;
      for (let index = 0; index < menuTargets.length; index++) {
        const { id, top, btm } = menuTargets[index];
        if (index === 0) {
          if (refPosition === null) {
            setRefPosition(top);
          } else {
            scrollingDown = top < refPosition;
            setRefPosition(top);
          }
        }

        if (scrollingDown) {
          if (top <= 0 && top >= -tolerance && activeId !== id) {
            update = true;
          }
        } else if (btm) {
          if (btm >= 0 && btm <= tolerance && activeId !== id) {
            update = true;
          }
        }
        if (update) {
          // determine a menu item was clicked to start scroll
          let justClicked = false;
          if (clickData.timestamp > 0) {
            // calculate time ellapsed since last click
            const now = Date.now();
            const interval = now - clickData.timestamp;
            justClicked = interval < 500; // time is in ms
          }
          if (!justClicked) {
            console.log("SubMenu: setting activeId to", id);
            setActiveId(id);
          }
          break;
        }
      }

      if (!scrollingDown && !update && activeId === "") {
        setActiveId(menuTargets[menuTargets.length - 1].id);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollSpy, links, activeId, bottomId, refPosition, clickData]);

  const onClick = React.useCallback(
    (currentId) => {
      setClickData({
        id: currentId,
        timestamp: Date.now(),
      });
      setActiveId(currentId);
    },
    [clickData],
  );

  const body = links.map((link, index) => {
    const {
      isVisible,
      to,
      label,
      resource,
      resources,
      resourceEvaluation,
      ...rest
    } = link;
    const show = isVisible !== undefined ? isVisible : true;
    const isReadable = evaluatePermissions(
      permissions,
      resource,
      resources,
      resourceEvaluation,
    );
    return !isReadable || !show ? null : (
      <li key={index}>
        <InpageNavLink
          id={`pagenav-${to}`}
          to={to}
          {...rest}
          activeClassName="active"
          currentTo={activeId}
          setCurrentTo={onClick}
        >
          {label}
        </InpageNavLink>
      </li>
    );
  });

  return (
    <div className={className}>
      <div className={`${contentClassName} nav-menu-vertical`}>
        <ul className={`w3-ul w3-large ${linkClassName}`}>{body}</ul>
      </div>
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PermissionInPageNavMenu);
